import { LOCATIONS, daysAgo, addressOf, requestBody, STREETS } from './dataset';

// Local Listings pages: Listing Management, RealityCheck™, Listing Performance, Media Management,
// Audit Logs, Edit History, Source Mapping. (/getLocations itself is in common.js.)
const [RIVERSIDE, NORTHGATE, HARBOUR, WESTFIELD, ELM] = LOCATIONS;

const fullName = loc => `Brightside Coffee - ${loc.locationName}`;

const mapsUrl = loc => `https://maps.google.com/?q=Brightside+Coffee+${encodeURIComponent(loc.locationName)}`;

const isoDate = iso => iso.slice(0, 10);

const NAMES = ['Dana Whitfield', 'Marc Oyelaran', 'Priya Raman', 'Tom Beckett', 'Alia Nasser']; // Charts: fortnightly points over the last ~3 months.

const series = make => [84, 70, 56, 42, 28, 14].map((ago, i) => ({
	date: isoDate(daysAgo(ago)),
	...make(i)
}));

const VIEW_KEYS = ['BUSINESS_IMPRESSIONS_DESKTOP_MAPS', 'BUSINESS_IMPRESSIONS_MOBILE_MAPS', 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH', 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH'];

const isActionsRequest = b => {
	const metrics = b && b.filters && b.filters.insightFilters && b.filters.insightFilters.metrics;
	return Array.isArray(metrics) && metrics.indexOf('ACTIONS_PHONE') !== -1;
}; // Bundled app images, so Media Management shows real thumbnails instead of broken links.


const PHOTOS = ['/images/location.jpg', '/images/bgbaneer.jpg', '/images/gmb.jpg', '/images/default3.jpg', '/images/facebook-posts-image.webp'];

const hours = (day, openTime, closeTime) => ({
	regularHours: {
		periods: [{
			openDay: day,
			closeDay: day,
			openTime,
			closeTime
		}]
	}
});

const auditRow = (id, loc, ago, diffType, updatedField, walmartValue, googleValue, updatedGoogleValue, google, error) => ({
	auditId: id,
	locationId: loc.locationId,
	storeCode: loc.storeCode,
	locationName: fullName(loc),
	googleUrl: mapsUrl(loc),
	openInfo: {
		status: 'OPEN'
	},
	address: addressOf(loc),
	createdTime: daysAgo(ago + 3),
	updatedTime: daysAgo(ago),
	diffType,
	updatedField,
	walmartValue,
	googleValue,
	updatedGoogleValue,
	status: {
		google
	},
	errorDetails: error ? {
		google: error
	} : {}
});

export default {
	// Listing Management — /getMasterDataStatus must have accountFetchStatuses; an empty fetch queue avoids polling.
	'/getMasterDataStatus': () => ({
		accountFetchStatuses: {
			'accounts/1029384756': {
				accountName: 'Brightside Coffee',
				status: 'COMPLETED',
				fetchType: 'MASTER_LOCATION'
			}
		}
	}),
	'/getFetchQueueStatus': () => [],
	'/getLocationGroups': () => ({
		entityTags: [{
			filterTagId: 'grp-wa-cafes',
			filterTagName: 'Washington cafés'
		}, {
			filterTagId: 'grp-or-cafes',
			filterTagName: 'Oregon cafés'
		}, {
			filterTagId: 'grp-flagships',
			filterTagName: 'Flagship stores'
		}],
		organisations: [{
			accountName: 'Brightside Coffee',
			name: 'accounts/1029384756'
		}]
	}),
	'/getLocationsCount': () => ({
		totalMasterLocationCount: 5,
		totalActiveLocationCount: 13,
		sources: {
			google: 5,
			yelp: 4,
			facebook: 4
		},
		healthScore: {
			google: 86
		}
	}),
	'/getLocationStatusCount': () => ({
		statusFields: {
			isVerified: 5,
			open: 5,
			isGoogleUpdated: 1
		},
		missingFields: {
			attributes: 2,
			brandLogo: 1,
			description: 1
		}
	}),
	'/getAppleSummary': () => ({
		companies: []
	}),
	'/getAppleCategories': () => ({
		categories: [{
			name: 'categories/coffee_shop',
			displayName: 'Coffee Shop',
			qualifiedId: 'coffee_shop'
		}, {
			name: 'categories/cafe',
			displayName: 'Cafe',
			qualifiedId: 'cafe'
		}]
	}),
	// RealityCheck™ — a COMPLETED edit status avoids polling.
	'/getWalmartEditStatus': () => ({
		hits: [{
			status: 'COMPLETED',
			processedCount: 5,
			totalCount: 5
		}]
	}),
	'/getWalmartAuditSummary': () => ({
		summary: {
			unMasked: {
				locationName: 1,
				phoneNumbers: 1,
				websiteUri: 1,
				regularHours: 2,
				openInfo: 0
			},
			masked: {
				regularHours: 1
			}
		}
	}),
	'/getWalmartAuditHistory': () => {
		const locations = [auditRow('aud-rc-001', RIVERSIDE, 1, 'GOOGLE_UPDATED', 'regularHours', hours('MONDAY', '06:00', '19:00'), hours('MONDAY', '06:00', '19:00'), hours('MONDAY', '07:00', '17:00'), 'PENDING'), auditRow('aud-rc-002', NORTHGATE, 2, 'GOOGLE_UPDATED', 'phoneNumbers', {
			phoneNumbers: {
				primaryPhone: '(503) 555-0172'
			}
		}, {
			phoneNumbers: {
				primaryPhone: '(503) 555-0172'
			}
		}, {
			phoneNumbers: {
				primaryPhone: '(503) 555-0199'
			}
		}, 'PENDING'), auditRow('aud-rc-003', HARBOUR, 3, 'WALMART_GOOGLE', 'websiteUri', {
			websiteUri: 'https://www.brightsidecoffee.com/locations/harbour'
		}, {
			websiteUri: 'https://brightsidecoffee.com/harbour-point'
		}, {}, 'FIRST_PARTY_PUBLISH'), auditRow('aud-rc-004', WESTFIELD, 1, 'GOOGLE_UPDATED', 'locationName', {
			locationName: fullName(WESTFIELD)
		}, {
			locationName: fullName(WESTFIELD)
		}, {
			locationName: 'Brightside Coffee & Bakery'
		}, 'GOOGLE_PUBLISH'), auditRow('aud-rc-005', RIVERSIDE, 1, 'WALMART_GOOGLE', 'regularHours', hours('SATURDAY', '07:00', '18:00'), hours('SATURDAY', '08:00', '16:00'), {}, 'FAILED', 'Google rejected the hours update for Saturday.')];
		return {
			total: locations.length,
			totalLocations: 4,
			diffTypeCount: {
				GOOGLE_UPDATED: 3,
				WALMART_GOOGLE: 2
			},
			updatedFieldCount: {
				regularHours: 2,
				phoneNumbers: 1,
				websiteUri: 1,
				locationName: 1
			},
			locations
		};
	},
	// Listing Performance — both histogram endpoints crash the page without a fixture.
	// The same endpoint serves views, actions and day-of-week charts; the request body says which.
	'/getPerformanceOverview': () => ({
		views: {
			totalViews: 48210,
			avgLocation: 9642,
			trendPercent: 6.4
		},
		mapViews: {
			mapViews: 29870,
			mapPercent: {
				BUSINESS_IMPRESSIONS_DESKTOP_MAPS: 22.4,
				BUSINESS_IMPRESSIONS_MOBILE_MAPS: 77.6
			},
			trendPercent: 4.1
		},
		searchViews: {
			searchViews: 18340,
			searchPercent: {
				BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: 31.2,
				BUSINESS_IMPRESSIONS_MOBILE_SEARCH: 68.8
			},
			trendPercent: 9.3
		},
		totalActions: {
			totalActions: 3954,
			actionsPercent: {
				ACTIONS_DRIVING_DIRECTIONS: 46.2,
				ACTIONS_PHONE: 21.5,
				ACTIONS_WEBSITE: 32.3
			}
		},
		conversionRate: {
			conversionRate: 8.2,
			conversionRatePercent: {
				ACTIONS_DRIVING_DIRECTIONS: 3.8,
				ACTIONS_PHONE: 1.8,
				ACTIONS_WEBSITE: 2.6
			},
			trendPercent: 1.2
		}
	}),
	// Only these keys: every key becomes a pie slice.
	'/getLocationInsightMetricCount': config => isActionsRequest(requestBody(config)) ? {
		ACTIONS_DRIVING_DIRECTIONS: 1827,
		ACTIONS_PHONE: 850,
		ACTIONS_WEBSITE: 1277
	} : {
		BUSINESS_IMPRESSIONS_DESKTOP_MAPS: 6690,
		BUSINESS_IMPRESSIONS_MOBILE_MAPS: 23180,
		BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: 5720,
		BUSINESS_IMPRESSIONS_MOBILE_SEARCH: 12620
	},
	'/getLocationInsightHistogram': config => {
		const b = requestBody(config);

		if ((b.graphType || []).indexOf('dayOfWeek') !== -1) {
			const days = [['Mon', 248, 118, 171], ['Tue', 236, 112, 165], ['Wed', 251, 121, 178], ['Thu', 262, 125, 184], ['Fri', 289, 131, 196], ['Sat', 301, 129, 205], ['Sun', 240, 114, 178]];
			return {
				histogram: {
					dayOfWeekHistogram: days.map(([dayOfWeek, d, p, w]) => ({
						dayOfWeek,
						ACTIONS_DRIVING_DIRECTIONS: d,
						ACTIONS_PHONE: p,
						ACTIONS_WEBSITE: w,
						value: d + p + w
					}))
				}
			};
		}

		if (isActionsRequest(b)) {
			return {
				histogram: series(i => ({
					ACTIONS_DRIVING_DIRECTIONS: 268 + i * 13,
					ACTIONS_PHONE: 131 + i * 4,
					ACTIONS_WEBSITE: 182 + i * 10
				}))
			};
		}

		return {
			histogram: series(i => ({
				[VIEW_KEYS[0]]: 1020 + i * 35,
				[VIEW_KEYS[1]]: 3610 + i * 93,
				[VIEW_KEYS[2]]: 880 + i * 30,
				[VIEW_KEYS[3]]: 1940 + i * 65
			}))
		};
	},
	'/getLocalActionConversionHistogram': () => ({
		histogram: series(i => ({
			DRIVING_DIRECTIONS_PERCENT: 3.6 + i * 0.08,
			PHONE_PERCENT: 1.7 + i * 0.04,
			WEBSITE_PERCENT: 2.4 + i * 0.06
		})),
		metricCount: [{
			ACTIONS_DRIVING_DIRECTIONS: {
				sum: 1827
			},
			ACTIONS_PHONE: {
				sum: 850
			},
			ACTIONS_WEBSITE: {
				sum: 1277
			},
			BUSINESS_IMPRESSIONS_DESKTOP_MAPS: {
				sum: 6690
			},
			BUSINESS_IMPRESSIONS_MOBILE_MAPS: {
				sum: 23180
			},
			BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: {
				sum: 5720
			},
			BUSINESS_IMPRESSIONS_MOBILE_SEARCH: {
				sum: 12620
			}
		}]
	}),
	// Media Management — every image needs a string storeCode.
	'/getAllLocationImages': config => {
		const isPublic = requestBody(config).type === 'public';
		const categories = ['EXTERIOR', 'INTERIOR', 'FOOD_AND_DRINK', 'EXTERIOR', 'FOOD_AND_DRINK'];
		const tags = [['storefront'], ['interior'], ['product'], ['exterior', 'patio'], ['product']];

		const images = LOCATIONS.map((loc, i) => ({
			name: `${STREETS[loc.locationId].googleId}/media/photo-${i + 1}`,
			locationId: loc.locationId,
			googleUrl: PHOTOS[i],
			mediaTags: tags[i],
			flaggedForRemoval: false,
			flaggedAsHidden: false,
			locationAssociation: {
				category: categories[i]
			},
			masterFriendlyName: loc.locationName,
			storeCode: loc.storeCode,
			createTime: daysAgo(14 + i * 7),
			mediaStatus: 'Live',
			insights: {
				viewCount: [1240, 860, 2315, 540, 1105][i]
			},
			type: isPublic ? 'public' : 'brand',
			...(isPublic ? {
				attribution: {
					profileName: ['Jordan Ellis', 'Sam Okafor', 'Riley Chen', 'Morgan Price', 'Casey Lindqvist'][i],
					profilePhotoUrl: ''
				}
			} : {
				owner: NAMES[i]
			})
		}));

		return {
			total: images.length,
			totalImages: images.length,
			totalVideos: 0,
			videos: [],
			images
		};
	},
	'/getLocationImageCount': () => ({
		images: [42, 35, 28, 21, 14].map(ago => ({
			date: isoDate(daysAgo(ago)),
			imageCount: 1,
			videoCount: 0
		}))
	}),
	// Audit Logs — auditTime must be a string.
	'/getListingAudits': () => {
		const audits = [{
			loc: RIVERSIDE,
			field: 'regularHours',
			type: 'edit',
			from: 'Mon 06:00-19:00',
			to: 'Mon 07:00-17:00'
		}, {
			loc: NORTHGATE,
			field: 'phoneNumbers',
			type: 'edit',
			from: '(503) 555-0172',
			to: '(503) 555-0199'
		}, {
			loc: HARBOUR,
			field: 'websiteUri',
			type: 'edit',
			from: 'https://www.brightsidecoffee.com/locations/harbour',
			to: 'https://brightsidecoffee.com/harbour-point'
		}, {
			loc: WESTFIELD,
			field: 'specialHours',
			type: 'add',
			from: '',
			to: 'Oct 31: 07:00-14:00'
		}, {
			loc: ELM,
			field: 'primaryCategory',
			type: 'edit',
			from: 'Coffee shop',
			to: 'Cafe'
		}, {
			loc: RIVERSIDE,
			field: 'title',
			type: 'delete',
			from: 'Brightside Coffee Riverside',
			to: ''
		}].map((a, i) => ({
			auditTime: daysAgo(i + 1),
			locationId: a.loc.locationId,
			locationName: fullName(a.loc),
			friendlyName: a.loc.locationName,
			updatedField: a.field,
			auditType: a.type,
			fromValue: a.from,
			toValue: a.to
		}));
		return {
			total: audits.length,
			audits
		};
	},
	'/getListingAuditSummary': () => ({
		deltaCount: 38,
		fetchCount: 7,
		locationCount: 5,
		updatedLocationCount: 4,
		tackedFieldCount: 16,
		// "tacked" is the spelling the page reads
		updatedFieldCount: 6,
		avgDelta: 5.4,
		auditTypes: {
			edit: 29,
			add: 6,
			delete: 3
		},
		updatedFields: [{
			field: 'regularHours',
			count: 12
		}, {
			field: 'specialHours',
			count: 8
		}, {
			field: 'phoneNumbers',
			count: 6
		}, {
			field: 'websiteUri',
			count: 5
		}, {
			field: 'primaryCategory',
			count: 4
		}, {
			field: 'title',
			count: 3
		}]
	}),
	'/getListingAuditHistogram': () => ({
		buckets: [[4, 1, 0], [6, 0, 1], [3, 2, 0], [5, 1, 0], [2, 0, 1], [6, 1, 0], [3, 1, 1]].map(([edit, add, del], i) => ({
			date: isoDate(daysAgo(7 - i)),
			edit,
			add,
			delete: del
		}))
	}),
	// Edit History — updatedFields must be a list; no QUEUE rows (they poll every 5 seconds).
	// Clicking a row reloads it with requestId to get per-location detail.
	'/getBulkEditHistory': config => {
		const mondayHours = {
			regularHours: {
				periods: [{
					closeDay: 'MONDAY',
					openTime: '06:00',
					closeTime: '18:00'
				}]
			}
		};

		if (requestBody(config).requestId) {
			const detail = (loc, status, error) => ({
				storeCode: loc.storeCode,
				locationName: fullName(loc),
				masterFriendlyName: loc.locationName,
				actionType: 'EDIT',
				updatedFields: ['regularHours'],
				updateMap: mondayHours,
				status,
				error: error || ''
			});

			const hits = [detail(RIVERSIDE, 'SUCCESS'), detail(HARBOUR, 'SUCCESS'), detail(ELM, 'ERROR', 'Location is pending Google verification.')];
			return {
				total: hits.length,
				hits
			};
		}

		const req = (n, ago, actionType, status, user, updatedFields, updateMap, total, success, failed, postStatus) => ({
			requestId: `req-${n}`,
			createTime: daysAgo(ago),
			actionType,
			status,
			userId: user,
			updatedFields,
			updateMap,
			totalLocationCount: total,
			processedLocationCount: total,
			successCount: success,
			failedCount: failed,
			postStatus: postStatus || ''
		});

		const hits = [req(1, 3, 'EDIT', 'UPDATED', NAMES[0], ['regularHours'], mondayHours, 5, 4, 1), req(2, 5, 'POST', 'PUBLISHED', NAMES[1], [], {}, 5, 5, 0, 'PUBLISHED'), req(3, 9, 'GROUPS', 'UPDATED', NAMES[2], [], {
			groupName: 'Washington cafés'
		}, 3, 3, 0), req(4, 14, 'MARK_AS', 'UPDATED', NAMES[3], ['openInfo'], {
			openInfo: {
				status: 'OPEN'
			}
		}, 1, 1, 0), req(5, 21, 'EDIT', 'FAILED', NAMES[4], ['primaryCategory'], {
			primaryCategory: {
				displayName: 'Coffee shop'
			}
		}, 2, 0, 2)];
		return {
			total: hits.length,
			hits
		};
	},
	// Source Mapping — a COMPLETED status avoids polling; mapped locations must not carry a requestId.
	'/getLocationMappingStatus': () => [{
		requestId: 'map-req-1007',
		status: 'COMPLETED',
		actionType: 'update_mapping',
		locationsProcessed: 5,
		locationsFetched: 5
	}],
	'/getMappedLocations': () => {
		const locations = LOCATIONS.map(loc => {
			const s = STREETS[loc.locationId];
			const key = loc.locationId.slice(4);
			return {
				masterLocationId: loc.locationId,
				masterLocationName: fullName(loc),
				googleLocationId: s.googleId,
				masterAddress: {
					storeCode: loc.storeCode,
					addressLines: s.street,
					locality: loc.city,
					administrativeArea: loc.state,
					postalCode: s.zip,
					country: 'US'
				},
				phoneNumber: s.phone,
				email: `${key}@brightsidecoffee.com`,
				description: `Brightside Coffee at ${loc.locationName}.`,
				connectedLocations: [{
					source: 'google',
					locationId: s.googleId,
					locationName: fullName(loc),
					address: {
						addressLines: [s.street],
						locality: loc.city,
						administrativeArea: loc.state,
						postalCode: s.zip
					}
				}, {
					source: 'facebook',
					id: `fb-${key}`,
					name: `Brightside Coffee ${loc.locationName}`,
					location: {
						street: s.street,
						city: loc.city,
						state: loc.state,
						zip: s.zip
					}
				}]
			};
		});

		return {
			total: locations.length,
			locations
		};
	},
	'/getUnmappedLocations': () => ({
		total: 3,
		locations: [{
			source: 'yelp',
			locationId: 'yelp-brightside-coffee-bend',
			locationName: 'Brightside Coffee',
			location: '640 NW Westfield Row, Bend, OR 97701'
		}, {
			source: 'facebook',
			id: 'fb-brightside-everett-kiosk',
			name: 'Brightside Coffee Everett Kiosk',
			location: {
				street: '2790 Elm St',
				city: 'Everett',
				state: 'WA',
				zip: '98201'
			}
		}, {
			source: 'google',
			locationId: 'accounts/1029384756/locations/5550099',
			locationName: 'Brightside Coffee Roastery',
			address: {
				addressLines: ['122 Harbour Point Blvd'],
				locality: 'Tacoma',
				administrativeArea: 'WA',
				postalCode: '98402'
			}
		}]
	}),
	'/getUnmappedLocationsSources': () => ({
		sources: [{
			source: 'google',
			count: 1
		}, {
			source: 'yelp',
			count: 1
		}, {
			source: 'facebook',
			count: 1
		}]
	})
};